var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Part3"},[_c('div',{staticClass:"w"},[_c('div',{staticClass:"titleBlack"},[_c('div',[_vm._v("助力传统粮食管理数字化升级")]),_c('div',{staticClass:"tipBlack"},[_vm._v("数字化管理的实现大大提高了粮食管理的效率，不受时间、空间等限制更灵活")])]),_c('img',{attrs:{"src":require("@/assets/image/solution/grain/part3@2x.png"),"alt":""}})])])
}]

export { render, staticRenderFns }